function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { retrieveServiceDetails } from '../../../../../../reducers/actions/services.actions';
import { CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { IsFetchingServiceDetailsSelector, SelectedServiceAssociatedDeviceAddonsSelector, SelectedServiceAssociatedDeviceFinanceDetailsSelector, SelectedServiceAssociatedDeviceFinanceDiscountsSelector, SelectedServiceAssociatedOfferDetailsSelector, SelectedServiceAssociatedServiceAddonsSelector, SelectedServiceAssociatedServiceIdSelector, SelectedServiceCurrencyCodeSelector, SelectedServiceDetailsSelector, SelectedServicePolicyCountersSelector, SharedEntitlementBalancesWithFormattedServiceIdentifierSelector } from '../../../../../../reducers/selectors/selected.service.details.selectors';
import { IsFetchingAddressesSelector } from '../../../../../../reducers/selectors/customer.addresses.selectors';
import { retrieveCustomerAddresses } from '../../../../../../reducers/actions/customer.addresses.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { NonTelcoUsageServiceFeatureToggleSelector } from '../../../../../../reducers/selectors/customer.actions.template.selectors';
var ServiceDetailsController = /*#__PURE__*/function () {
  function ServiceDetailsController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ServiceDetailsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      fetchServiceDetails: this.fetchServiceDetails.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServiceDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        retrieveCustomerAddresses: retrieveCustomerAddresses,
        retrieveServiceDetails: retrieveServiceDetails
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currencyCode: SelectedServiceCurrencyCodeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          deviceAddons: SelectedServiceAssociatedDeviceAddonsSelector(store),
          deviceFinanceDetails: SelectedServiceAssociatedDeviceFinanceDetailsSelector(store),
          deviceFinanceDiscounts: SelectedServiceAssociatedDeviceFinanceDiscountsSelector(store),
          featureTogglesLoaded: MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
          isFetchingAddresses: IsFetchingAddressesSelector(store),
          isNonTelcoUsageServicePageEnabled: NonTelcoUsageServiceFeatureToggleSelector(store),
          isFetchingServiceDetails: IsFetchingServiceDetailsSelector(store),
          isUnitOfMeasurementLoaded: MetadataCodeLoadedSelector(CODES.UnitsOfMeasure, store),
          offerDetails: SelectedServiceAssociatedOfferDetailsSelector(store),
          policyCounters: SelectedServicePolicyCountersSelector(store),
          serviceAddons: SelectedServiceAssociatedServiceAddonsSelector(store),
          serviceDetails: SelectedServiceDetailsSelector(store),
          serviceId: SelectedServiceAssociatedServiceIdSelector(store),
          sharedEntitlementBalances: SharedEntitlementBalancesWithFormattedServiceIdentifierSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.isUnitOfMeasurementLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.UnitsOfMeasure);
      }
      if (!this.state.featureTogglesLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.FeatureToggleConfig);
      }
      this.fetchServiceDetails();
      this.fetchAddress();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.serviceIdentifier && changesObj.serviceIdentifier.currentValue && this.actions) {
        this.fetchServiceDetails();
      }
    }
  }, {
    key: "fetchServiceDetails",
    value: function fetchServiceDetails() {
      var _this2 = this;
      if (this.serviceIdentifier) {
        var serviceIdentifiers = [{
          Value: this.serviceIdentifier
        }];
        this.actions.retrieveServiceDetails(this.state.currentCustomerId, serviceIdentifiers).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "fetchAddress",
    value: function fetchAddress() {
      var _this3 = this;
      this.actions.retrieveCustomerAddresses(this.state.currentCustomerId, false).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "onRefreshConvergentBillerDetails",
    value: function onRefreshConvergentBillerDetails() {
      this.refreshConvergentBillerDetails && this.refreshConvergentBillerDetails();
    }
  }]);
}();
export default {
  bindings: {
    hideServiceTaxDetails: '<?',
    refreshConvergentBillerDetails: '&?',
    serviceIdentifier: '<'
  },
  template: require('./service.details.html'),
  controller: ServiceDetailsController
};